const { Flex, Text, Image, Box } = require('@chakra-ui/react')

const CollapsedMeeting = ({meeting, setActive}) => {
  return (
    <Flex 
      opacity={ !meeting.summary && !meeting.isUpcoming ? 0.4 : 1 } 
      h='78px' mt={2} 
      flexDirection='column' 
      border={'1px solid'} 
      cursor='pointer' 
      onClick={() => setActive()}
    >
      <Flex alignItems='center'>
        <Text color='brandTextBlack' fontWeight='500'>
          {meeting.title}
        </Text>
        {meeting.isRecurring  && (
          <Image cursor='pointer' ml='15px' mt={1} boxSize={4} color='brandTextBlack' src='/assets/icons/recurringEvent.svg' />
        )}
        
      </Flex>

      <Flex mt='7px' alignItems='center'>
        <Text color='brandTextGrey2' lineHeight='19px'>
          {meeting.time} • {meeting.duration}
        </Text>

        <Box ml='auto' />

        {meeting.tags && meeting.tags.map(({color, name: tag}, index) => (
          <Flex ml={5} key={`${meeting.eventId}-${tag}-${index}`} alignItems='center'>
            <Box mt={1} boxSize={3} bg={color ?? '#4E60E2'} borderRadius='full' />
            <Text
              color='brandTextGrey2'
              flex={1}
              ml={2.5}
              lineHeight='21.6px'
              noOfLines={1}
              wordBreak='break-all'
              cursor='pointer'
            >
              {tag}
            </Text>
          </Flex>
        ))}

        {meeting.functions && meeting.functions.map(({function: f}, index) => (
          <Flex ml={5} key={`${meeting.eventId}-${f}-${index}`}>
            <Text
              color='brandTextGrey2'
              flex={1}
              lineHeight='21.6px'
              noOfLines={1}
              wordBreak='break-all'
              cursor='pointer'
            >
              {f}
            </Text>
          </Flex>
        ))}
      </Flex>

      <Box bg='#CFCFCF' w='full' h='2px' mt={4} />
    </Flex>
  )
}

export default CollapsedMeeting